import { render } from "./PointIcon.vue?vue&type=template&id=202cc33e"
import script from "./PointIcon.vue?vue&type=script&lang=js"
export * from "./PointIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__